// src/Views/HomePage.js
import React from 'react';
import './HomePage.css';

import Header from './Header.js';

const HomePage = () => {
  return (
    <div className="cafe-homepage">
      <Header />
    </div>
  );
};

export default HomePage;